import { render, staticRenderFns } from "./PopUpAñadirInformesDiagnostico.vue?vue&type=template&id=aad7a518&scoped=true"
import script from "./PopUpAñadirInformesDiagnostico.vue?vue&type=script&lang=js"
export * from "./PopUpAñadirInformesDiagnostico.vue?vue&type=script&lang=js"
import style0 from "./PopUpAñadirInformesDiagnostico.vue?vue&type=style&index=0&id=aad7a518&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad7a518",
  null
  
)

export default component.exports